import { Quote, Clock, ArrowUpRight } from "lucide-react";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import { TESTIMONIALS, BLOG_PREVIEW } from "@/lib/sipl-content";

export default function TestimonialsBlog() {
  return (
    <section
      id="insights"
      data-testid="insights-section"
      className="section-y bg-white"
    >
      <div className="container-x">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12">
          <div className="lg:col-span-5">
            <div className="text-sm uppercase tracking-[0.22em] text-sipl-secondary mb-4 dash-accent">
              Testimonials
            </div>
            <h2 className="font-heading text-3xl md:text-4xl text-sipl-primary font-semibold tracking-tight leading-[1.08]">
              Voices from the field.
            </h2>

            <Carousel
              className="mt-8"
              data-testid="testimonial-carousel"
              opts={{ loop: true, align: "start" }}
            >
              <CarouselContent>
                {TESTIMONIALS.map((t, idx) => (
                  <CarouselItem key={idx}>
                    <div className="sipl-card p-7 lg:p-8 min-h-[220px] flex flex-col">
                      <Quote className="w-7 h-7 text-sipl-accent" />
                      <p className="mt-5 text-sipl-fg/80 text-base leading-relaxed">
                        "{t.quote}"
                      </p>
                      <div className="mt-auto pt-6 border-t border-sipl-line">
                        <div className="font-heading text-sipl-primary font-medium">
                          {t.author}
                        </div>
                        <div className="text-xs text-sipl-muted uppercase tracking-[0.18em] mt-1">
                          {t.org}
                        </div>
                      </div>
                    </div>
                  </CarouselItem>
                ))}
              </CarouselContent>
              <div className="flex gap-2 mt-5">
                <CarouselPrevious
                  data-testid="testimonial-prev"
                  className="static translate-y-0 translate-x-0 bg-white border-sipl-line text-sipl-primary hover:bg-sipl-primary hover:text-white"
                />
                <CarouselNext
                  data-testid="testimonial-next"
                  className="static translate-y-0 translate-x-0 bg-white border-sipl-line text-sipl-primary hover:bg-sipl-primary hover:text-white"
                />
              </div>
            </Carousel>
          </div>

          <div className="lg:col-span-7">
            <div className="flex items-end justify-between mb-8">
              <div>
                <div className="text-sm uppercase tracking-[0.22em] text-sipl-secondary mb-3 dash-accent">
                  From the SIPL desk
                </div>
                <h2 className="font-heading text-3xl md:text-4xl text-sipl-primary font-semibold tracking-tight leading-[1.08]">
                  Insights & briefings.
                </h2>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
              {BLOG_PREVIEW.map((b, idx) => (
                <article
                  key={b.title}
                  data-testid={`blog-card-${idx}`}
                  className="sipl-card overflow-hidden flex flex-col group cursor-pointer"
                >
                  <div className="aspect-[4/3] overflow-hidden">
                    <img
                      src={b.image}
                      alt={b.title}
                      loading="lazy"
                      className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                    />
                  </div>
                  <div className="p-5 flex flex-col flex-1">
                    <div className="flex items-center gap-3 text-[11px] uppercase tracking-[0.18em] text-sipl-muted mb-3">
                      <span className="text-sipl-secondary">{b.tag}</span>
                      <span className="flex items-center gap-1">
                        <Clock className="w-3 h-3" />
                        {b.minutes} min
                      </span>
                    </div>
                    <h3 className="font-heading text-base font-medium text-sipl-primary leading-snug">
                      {b.title}
                    </h3>
                    <span className="mt-auto pt-5 link-underline text-xs font-medium text-sipl-primary group-hover:text-sipl-accent">
                      Read briefing <ArrowUpRight className="w-3.5 h-3.5" />
                    </span>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
